import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarTransportationRoutesQueryAtom = createQueryAtomFactory(
  'calendar.transportationRoutes',
  (params: { fromDate: string; toDate: string }) => {
    const filter: Record<string, unknown> = {
      routeDateAfter: `${params.fromDate}T00:00:00Z`,
      routeDateBefore: `${params.toDate}T23:59:59Z`,
    };

    return {
      routes: {
        __args: {
          filter,
          pagination: {
            limit: 500,
            offset: 0,
          },
        },
        entries: {
          id: true,
          documentNumber: true,
          status: true,
          routeDate: true,
          facilityGroupId: true,
        },
        page: {
          total: true,
        },
      },
    };
  },
);
